import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.52325 15.2965H4.93746L15.3014 4.93258L11.0588 0.689941L0.694824 11.0539V15.2965H4.52325ZM2.69482 11.8823L11.0588 3.51837L12.473 4.93258L4.10904 13.2965H2.69482V11.8823Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.59473 3.8042L12.4232 6.63263L11.0089 8.04684L8.18051 5.21841L9.59473 3.8042Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgEditSmall);
export { ForwardRef as ReactComponent };
